import { render, staticRenderFns } from "./AutocompleteAcaPeriod.vue?vue&type=template&id=b640ce94&scoped=true"
import script from "./AutocompleteAcaPeriod.vue?vue&type=script&lang=js"
export * from "./AutocompleteAcaPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b640ce94",
  null
  
)

export default component.exports